import { onContactSupport } from '../../utils/HelpArticleButton';
import React from 'react';

type ErrorProps = {
  error: any;
};

const Error = ({ error }: ErrorProps) => {
  //eslint-disable-next-line
  if (window.bugsnagClient) {
    window.bugsnagClient.notify(error);
  } else {
    console.error(error);
  }

  return (
    <div style={{ paddingLeft: '12px' }}>
      <>
        <p>
          Oops! Something went wrong. We encountered an unexpected error. Please{' '}
          <a onClick={onContactSupport}>contact support</a> for assistance.
        </p>
        {error && (
          <pre
            style={{ padding: '12px', maxHeight: '75px', overflow: 'hidden' }}
          >
            {error.message}
            {error.stack}
          </pre>
        )}
      </>
    </div>
  );
};

export default Error;
